// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bold-part[data-v-89731c4a]{font-weight:900}#main-container[data-v-89731c4a]{max-width:1280px;margin:0 auto;position:relative;padding-top:2em;min-height:500px;display:flex;flex-direction:column;align-items:center}#main-container .btn-error[data-v-89731c4a]{max-width:300px;margin-top:2em}", ""]);
// Exports
module.exports = exports;
